import { request } from './core'

export const intakeApi = {
  finalizeIntake: (slug: string, revision?: number) =>
    request<{ ok: boolean; revision?: number }>(
      `/api/assessments/${slug}/finalize`,
      { method: 'POST' },
      { ifMatch: revision },
    ),

  putSectionFields: (
    slug: string,
    sectionKey: string,
    values: Record<string, unknown>,
    revision?: number,
  ) =>
    request<{ ok: boolean; saved_keys: string[]; unknown_keys: string[]; revision?: number }>(
      `/api/assessments/${slug}/fields/${sectionKey}`,
      { method: 'PUT', body: JSON.stringify({ values }) },
      { ifMatch: revision },
    ),
}
